const createQuery = () => `
  ... on EventFormWidget {
    id
    type
    formBuilder {
      _id
      title
      questions {
        question
        width
        required
      }
      thankyouMessage
    }
  }
`

export default createQuery
